import {AfterViewInit, Component, Inject, OnInit, ViewChild} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { ReleaseNoteService } from '../release-note.service';
import { TinymceComponent } from 'angular2-tinymce';
import { AuthService } from '../../../core/auth.service';
import * as _ from 'lodash';
import { AppService } from '../../../app.service';
import { Subscription } from 'rxjs';
import { VideosModalComponent } from '../../video/modals/videos-modal.component';
import { VideosService } from '../../video/videos.service';
import {MAT_DIALOG_DATA} from "@angular/material/dialog";

@Component({
    templateUrl: 'release-note-modal.component.html',
    styleUrls: ['release-note-modal.component.scss'],
    providers: [
        ReleaseNoteService,
        VideosService
    ]
})

export class ReleaseNoteModalComponent extends VideosModalComponent implements OnInit, AfterViewInit {
    type: string;
    url = 'release-note';
    errorMessage: any;
    successMessage = '';
    formSubmitted: boolean = false;
    params: any = {};
    queryParams: any = {};
    id = null;
    // value null cause match api defined
    form: FormGroup;
    defaultContent: string = '';
    releaseNote: any = {};
    releaseNoteURL: string;
    showRevertButton: boolean = false;
    thumbnail = '';
    isImageSaved = false;
    imageError: any;
    language: 'DE';
    subscribe: Subscription;

    noTitleTypeArr = [
        'support',
        'clinic_support',
        'help_patients',
        'help_patient',
        'help_di_overview',
        'help_di_symptom',
        'help_home',
    ];

    @ViewChild('modal', {static: false}) protected modal: ModalDirective;
    @ViewChild('releaseNoteDescription', {static: false}) private releaseNoteDescription: TinymceComponent;

    constructor(protected fb: FormBuilder,
                public authService: AuthService,
                public route: ActivatedRoute,
                public router: Router,
                protected appService: AppService,
                public videosService : VideosService,
                public releaseNoteService: ReleaseNoteService) {
        super(fb, authService, route, router, appService, videosService);
    }

    ngOnInit() {
        super.ngOnInit();
        this.appService.isLoading = false;
    }

    ngAfterViewInit() {
        super.ngAfterViewInit();
    }

    buildForm(): void {
        this.form = this.fb.group({
            'id': [''],
            'language': [''],
            // 'title': ['', [Validators.required]],
            'version': ['', [Validators.required]],
            'description': ['', [Validators.required]],
            'show': [true],
            // 'picture': ['']
        });
    }

    hideModal() {
        this.subscribe.unsubscribe();
        this.router.navigate([this.url],
            {
                relativeTo: this.route.parent,
                queryParams: {
                    lang: this.language
                }
            });
    }

    loadModalData() {
        this.form.controls.language.setValue(this.language);
        if (!this.params['id']) {
            return false;
        }
        this.releaseNoteService.read(this.params['id'], this.language)
            .subscribe(response => {
                    this.releaseNote = response['release_note'];

                    this.releaseNote['language_flag'] = '/assets/icon/flags/' + this.language.toLowerCase() + '.png';
                    this.form.controls.version.setValue(this.releaseNote['version']);
                    this.form.controls.description.setValue(this.releaseNote['description']);
                    this.thumbnail = this.releaseNote['picture_url'] ? this.releaseNote['picture_url'] : null;
                    this.releaseNoteURL = this.releaseNote['releaseNote_url'] ? this.releaseNote['releaseNote_url'] : null;
                    this.form.controls.id.setValue(this.id);
                    this.form.controls.show.setValue(this.releaseNote['show']);
                }
            );
    }

    showModal() {
        this.modal.show();
    }

    /**
     * Submit update of email templates
     *
     * @param emailTranslationForm
     * @param {boolean} isValid
     */
    submit(releaseNoteForm: any, isValid: boolean): void {
        this.formSubmitted = true;

        if (!isValid) {
            return;
        }

        this.resetErrors();
        this.appService.isLoading = true;
        this.releaseNoteService.save(this.id, releaseNoteForm, this.language).subscribe(
            response => {
                this.successMessage = response['message'];
                this.appService.isLoading = false;
                setTimeout(() => {
                    this.successMessage = '';
                    this.hideModal();
                }, 1000);
            }, (error) => {
                this.errorMessage = this.appService.parseErrors(error);
                this.appService.isLoading = false;
            });
    }

    resetErrors() {
        if (this.errorMessage.length > 0) {
            this.errorMessage = '';
        }
    }

}
